/**
 * Check if a Unix timestamp is in the future or within the last two weeks
 */
const isUnixDateInFutureOrWithinLastTwoWeeks = (unixTimestamp: number): boolean => {
    const timestampInMs = unixTimestamp * 1000
    const now = Date.now()
    const twoWeeksInMs = 12096e5 // 14 days in milliseconds
    return timestampInMs > now - twoWeeksInMs
}

/**
 * Get URL parameter value by name
 */
const getUrlParameter = (name: string): string | null => {
    const params = new URLSearchParams(window.location.search)
    return params.get(name)
}

/**
 * Format Unix timestamp to readable date string
 */
const formatDate = (unixTimestamp: number): string => {
    const date = new Date(unixTimestamp * 1000)
    const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec']

    const day = String(date.getDate()).padStart(2, '0')
    const month = months[date.getMonth()]
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')

    return `${day} ${month} ${year} - ${hours}:${minutes}`
}

/**
 * Initialize survey form with show data
 */
export const initSurveyForm = async (): Promise<void> => {
    // Find form by handle instead of hardcoded ID
    const surveyForm = document.querySelector('[data-fui-form*=\'"formHandle":"enquete"\']') as HTMLFormElement

    if (!surveyForm) {
        return
    }

    // Extract formHashId from data-fui-form attribute
    const formDataAttr = surveyForm.getAttribute('data-fui-form')
    if (!formDataAttr) {
        return
    }

    let formHashId: string
    try {
        const formData = JSON.parse(formDataAttr)
        formHashId = formData.formHashId
    } catch (e) {
        console.error('Failed to parse form data:', e)
        return
    }

    const enqueteVoorstellingId = getUrlParameter('voorstelling_id')

    if (!enqueteVoorstellingId) {
        return
    }

    // Get show data directly from Itix
    const showData = await (
        await fetch(`${window.itixBackendUrl}/framework/public/ajax/site/show.php?action=getShows`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filter: {
                    show: { id: { eq: enqueteVoorstellingId } },
                },
                limit: 1,
            }),
        })
    ).json()

    if (!showData || !showData.message || showData.message.length === 0) {
        return
    }

    const info = showData.message[0]

    // Check if the show date is valid (convert from ISO date string to unix timestamp)
    const showFromTimestamp = info.from ? Math.floor(new Date(info.from).getTime() / 1000) : null
    if (showFromTimestamp && !isUnixDateInFutureOrWithinLastTwoWeeks(showFromTimestamp)) {
        surveyForm.innerHTML =
            '<div class="enquete_passed"><strong>De invulperiode voor deze enquete is verstreken.</strong></div>'
        return
    }

    // Fill in hidden voorstellingId field
    const voorstellingIdField = document.getElementById(
        `${formHashId}-fields-voorstelling-voorstellingId`
    ) as HTMLInputElement
    if (voorstellingIdField) {
        voorstellingIdField.value = enqueteVoorstellingId
    }

    // Fill in form fields
    const voorstellingField = document.getElementById(
        `${formHashId}-fields-voorstelling-voorstelling1`
    ) as HTMLInputElement
    if (voorstellingField && info.title) {
        voorstellingField.value = info.title
        voorstellingField.readOnly = true
    }

    const artiestField = document.getElementById(`${formHashId}-fields-voorstelling-artiest`) as HTMLInputElement
    if (artiestField && info.subtitle) {
        artiestField.value = info.subtitle
        artiestField.readOnly = true
    }

    const datumField = document.getElementById(`${formHashId}-fields-voorstelling-datum`) as HTMLInputElement
    if (datumField && showFromTimestamp) {
        datumField.value = formatDate(showFromTimestamp)
        datumField.readOnly = true
    }

    const genreField = document.getElementById(`${formHashId}-fields-voorstelling-genre`) as HTMLInputElement
    if (genreField && info.subgenres && info.subgenres[0]) {
        genreField.value = info.subgenres[0].title
        genreField.readOnly = true
    }
}
